<template>
  <div class="tp-check-form">
    <div class="form-row align-items-end">
      <div class="form-group col-md-2 mb-2">
        <label class="form-card__label">N&uacute;mero</label>
        <input v-model="number" type="number" min="0" class="form-control">
      </div>
      <div class="form-group col mb-2">
        <label class="form-card__label">Banco</label>
        <input v-model="bankname" type="text" class="form-control">
      </div>
      <div class="form-group col-md-2 mb-2">
        <label class="form-card__label">Fecha cobro</label>
        <masked-input v-model="datedue" required mask="11/11/1111" placeholder="dd/mm/yyyy" class="form-control"/>
      </div>
      <div class="form-group col-md-2 mb-2">
        <label class="form-card__label">Monto</label>
        <input v-model.number="amount" type="number" min="0" step="0.01" class="form-control">
      </div>
    </div>

    <div class="form-row align-items-end">
      <div class="form-group col mb-2">
        <label class="form-card__label">Nombre cliente</label>
        <input v-model="clientname" class="form-control">
      </div>
      <div class="form-group col-md-3 mb-2">
        <label class="form-card__label">CUIT cliente</label>
        <input v-model.number="clientcuit" type="number" min="0" class="form-control" required>
      </div>
      <div class="form-group col-md-2 mb-2">
        <label class="form-card__label">Tipo</label>
        <select v-model="checkKind" class="form-control">
          <option v-for="opt in checkKindOptions" :key="opt.value" :value="opt.value">
            {{ opt.text }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-auto mb-2">
        <div class="tp-check-form__buttons">
          <span id="resetPaymentAction" @click="reset()" class="delete-product" aria-hidden="true" title="Eliminar">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
            </svg>
          </span>
          <span id="savePaymentAction" v-if="validate" @click="save()" class="ok-payment-method" aria-hidden="true" title="Grabar">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="green" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import maskedInput from 'vue-masked-input';
import { CHECK_KIND_OPTIONS } from '../../../../constants/checkKind';

export default {
  data: function() {
    return {
      res: {},
      clientcuit: null,
      clientname: null,
      amount: 0,
      datedue: null,
      bankname: '',
      number: null,
      checkKind: 'fisico',
      checkKindOptions: CHECK_KIND_OPTIONS,
    }
  },
  components: {
    maskedInput
	},
  methods: {
		reset: function () {
      this.$emit('tpcheckcancel');
    },
    save: function () {
			this.res.clientcuit = this.clientcuit;
			this.res.clientname = this.clientname;
			this.res.amount = this.amount;
      this.res.datedue = this.datedue;
      this.res.bankname = this.bankname;
      this.res.number = this.number;
      this.res.check_kind = this.checkKind;

      this.$emit('tpchecksaved',this.res);
    }
	},
	computed: {
		validate () {
			let vm = this;
      return (vm.number !=null && vm.bankname != '' && vm.amount > 0 && vm.datedue!=null && vm.clientname!=null && vm.clientcuit!=null);
    }
  }
}
</script>

<style scoped>
.tp-check-form__buttons {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: calc(1.5em + 0.75rem + 2px);
}

.tp-check-form__buttons .delete-product,
.tp-check-form__buttons .ok-payment-method {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}
</style>
